<template>
  <div>
    <div class="find-space-home-greeting" v-if="!publicView">Hi{{ user ? ' ' + user.first_name : ''}}, start your search here</div>
    <div class="mb-4 find-space-home-search-container">
      <inline-location-search class="hirer-tools"/>
    </div>
    <div class="find-space-home-container">
      <div class="find-space-home-block">
        <!-- <div class="find-space-home-video background tinted" @click="openVideoModal('https://vimeo.com/883860017')"> -->
        <div class="find-space-home-video background">
          <img src="/images/placeholders/shortlists.jpeg" class="video-thumbnail"/>
          <!-- <div class="play-btn-container">
            <svg xmlns="http://www.w3.org/2000/svg">
              <image xlink:href="/images/icons/video-circle.svg" />
            </svg>
          </div> -->
        </div>
        <div class="find-space-text-content">
          <div class="find-space-heading">Search,<br/> Shortlist, Book</div>
          <div>
            We make it easy to search, shortlist and book a location for your next production.
            <ul class="mt-2">
              <li>Stills shoot</li>
              <li>Events</li>
              <li>TVC's</li>
              <li>Film</li>
              <li>Activations</li>
            </ul>
          </div>
        </div>
        <div class="find-space-btn">
          <button class="button primary" @click="goToShortlists">Create a shortlist</button>
        </div>
      </div>
      <div class="find-space-home-block">
        <!-- <div class="find-space-home-video background tinted" @click="openVideoModal('https://vimeo.com/883860017')"> -->
        <div class="find-space-home-video background">
          <img src="/images/placeholders/briefs.jpeg" class="video-thumbnail"/>
          <!-- <div class="play-btn-container">
            <svg xmlns="http://www.w3.org/2000/svg">
              <image xlink:href="/images/icons/video-circle.svg" />
            </svg>
          </div> -->
        </div>
        <div class="find-space-text-content">
          <div class="find-space-heading">Brief us</div>
          <div>Simply fill in our brief form to enable us to shortlist the best locations to suit your brief, crew size and budget.</div>
        </div>
        <div class="find-space-btn">
          <button class="button primary" @click="goToBriefs"  click_text="Brief Us">Brief us here</button>
        </div>
      </div>
      <div class="find-space-home-block transparent">
        <div class="find-space-home-img">
          <img src="/images/placeholders/letschat.jpeg" />
        </div>
        <div class="find-space-text-content">
          <div class="find-space-title">We make it easy to book the perfect space for your next production</div>
          Search our unique locations on a national stage, tapping into local knowlegde
        </div>
        <div class="find-space-btn" @click="openChat">
          <button class="button chat-btn-transparent">Chat now</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    closeModal() {
        this.$emit('closeModal');
    },
    goToLogin() {
      this.closeModal();
      this.$store.commit("user/setShouldBeRedirectedToFindYourSpace", true);
      this.$store.commit("user/changeAuthMode", "login");
    },
    goToShortlists() {
      if (!this.user) {
        return this.goToLogin();
      }
      this.$store.commit('findspace/navigateToSubpage', { page: 'shortlists', subpage: 'home' });
    },
    goToBriefs() {
      if (!this.user) {
        return this.goToLogin();
      }
      this.$store.commit('findspace/navigateToSubpage', { page: 'briefs', subpage: 'home' });
    },
    getVideoCode(videoUrl) {
      return videoUrl.split("/").pop();
    },
    openVideoModal(videoUrl) {
      this.$store.dispatch('modals/showFullscreenVideo', {
        videoCode: this.getVideoCode(videoUrl)
      })
    },
    openChat() {
      this.$store.dispatch("intercom/openNewChat");
    }
  },
  computed: {
    user () {
      return this.$store.getters['user/account']
    },
    publicView() {
      return this.$store.getters['findspace/public']
    },
  },
}
</script>
